(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('@angular/core'), require('@angular/common'), require('@shraddhar/web/form-field'), require('@angular/forms'), require('@angular/cdk/coercion'), require('@angular/cdk/platform'), require('rxjs'), require('rxjs/operators'), require('@shraddhar/web/dom'), require('@material/ripple'), require('@material/checkbox'), require('@shraddhar/web/base'), require('@shraddhar/web/ripple')) :
    typeof define === 'function' && define.amd ? define('@shraddhar/web/checkbox', ['exports', '@angular/core', '@angular/common', '@shraddhar/web/form-field', '@angular/forms', '@angular/cdk/coercion', '@angular/cdk/platform', 'rxjs', 'rxjs/operators', '@shraddhar/web/dom', '@material/ripple', '@material/checkbox', '@shraddhar/web/base', '@shraddhar/web/ripple'], factory) :
    (global = global || self, factory((global.shraddhar = global.shraddhar || {}, global.shraddhar.web = global.shraddhar.web || {}, global.shraddhar.web.checkbox = {}), global.ng.core, global.ng.common, global.ng.web.formField, global.ng.forms, global.ng.cdk.coercion, global.ng.cdk.platform, global.rxjs, global.rxjs.operators, global.ng.web.dom, global.mdc.ripple, global.mdc.checkbox, global.ng.web.base, global.ng.web.ripple));
}(this, (function (exports, core, common, formField, forms, coercion, platform, rxjs, operators, dom, ripple, checkbox, base, ripple$1) { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0

    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.

    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __rest(s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                    t[p[i]] = s[p[i]];
            }
        return t;
    }

    function __decorate(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    }

    function __param(paramIndex, decorator) {
        return function (target, key) { decorator(target, key, paramIndex); }
    }

    function __metadata(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
    }

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    function __exportStar(m, exports) {
        for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
    }

    function __values(o) {
        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === "number") return {
            next: function () {
                if (o && i >= o.length) o = void 0;
                return { value: o && o[i++], done: !o };
            }
        };
        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
    }

    function __read(o, n) {
        var m = typeof Symbol === "function" && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o), r, ar = [], e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        }
        catch (error) { e = { error: error }; }
        finally {
            try {
                if (r && !r.done && (m = i["return"])) m.call(i);
            }
            finally { if (e) throw e.error; }
        }
        return ar;
    }

    function __spread() {
        for (var ar = [], i = 0; i < arguments.length; i++)
            ar = ar.concat(__read(arguments[i]));
        return ar;
    }

    function __spreadArrays() {
        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
        for (var r = Array(s), k = 0, i = 0; i < il; i++)
            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
                r[k] = a[j];
        return r;
    };

    function __await(v) {
        return this instanceof __await ? (this.v = v, this) : new __await(v);
    }

    function __asyncGenerator(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var g = generator.apply(thisArg, _arguments || []), i, q = [];
        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
        function fulfill(value) { resume("next", value); }
        function reject(value) { resume("throw", value); }
        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
    }

    function __asyncDelegator(o) {
        var i, p;
        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
    }

    function __asyncValues(o) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var m = o[Symbol.asyncIterator], i;
        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
    }

    function __makeTemplateObject(cooked, raw) {
        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
        return cooked;
    };

    function __importStar(mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
        result.default = mod;
        return result;
    }

    function __importDefault(mod) {
        return (mod && mod.__esModule) ? mod : { default: mod };
    }

    function __classPrivateFieldGet(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
    }

    function __classPrivateFieldSet(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
    }

    var nextUniqueId = 0;
    /** Change event object emitted by MdcCheckbox. */
    var MdcCheckboxChange = /** @class */ (function () {
        function MdcCheckboxChange(
        /** The source MdcCheckbox of the event. */
        source, 
        /** The new `checked` value of the checkbox. */
        checked) {
            this.source = source;
            this.checked = checked;
        }
        return MdcCheckboxChange;
    }());
    var MDC_CHECKBOX_CONTROL_VALUE_ACCESSOR = {
        provide: forms.NG_VALUE_ACCESSOR,
        useExisting: core.forwardRef(function () { return MdcCheckbox; }),
        multi: true
    };
    var MdcCheckbox = /** @class */ (function (_super) {
        __extends(MdcCheckbox, _super);
        function MdcCheckbox(_platform, _ngZone, _changeDetectorRef, elementRef, ripple, _parentFormField) {
            var _this = _super.call(this, elementRef) || this;
            _this._platform = _platform;
            _this._ngZone = _ngZone;
            _this._changeDetectorRef = _changeDetectorRef;
            _this.elementRef = elementRef;
            _this.ripple = ripple;
            _this._parentFormField = _parentFormField;
            /** Emits whenever the component is destroyed. */
            _this._destroy = new rxjs.Subject();
            _this._initialized = false;
            _this._uniqueId = "mdc-checkbox-" + ++nextUniqueId;
            _this.id = _this._uniqueId;
            _this.name = null;
            _this._checked = false;
            _this._touch = false;
            _this._disabled = false;
            /** The value attribute of the native input element */
            _this.value = null;
            _this._indeterminate = false;
            _this._indeterminateToChecked = true;
            _this._disableRipple = false;
            _this.tabIndex = 0;
            _this.ariaLabel = '';
            _this.ariaLabelledby = null;
            /**
             * Fired when checkbox is checked or unchecked, but not when set
             * indeterminate. Sends the state of [checked].
             */
            _this.change = new core.EventEmitter();
            /**
             * Fired when checkbox goes in and out of indeterminate state, but not when
             * set to checked. Sends the state of [indeterminate];
             */
            _this.indeterminateChange = new core.EventEmitter();
            /** View to model callback called when value changes */
            _this._onChange = function () { };
            /** View to model callback called when component has been touched */
            _this._onTouched = function () { };
            _this._root = _this.elementRef.nativeElement;
            if (_this._parentFormField) {
                _parentFormField.elementRef.nativeElement.classList.add('mdc-form-field');
            }
            return _this;
        }
        Object.defineProperty(MdcCheckbox.prototype, "inputId", {
            /** Returns the unique id for the visual hidden input. */
            get: function () {
                return (this.id || this._uniqueId) + "-input";
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcCheckbox.prototype, "checked", {
            get: function () {
                return this._checked;
            },
            set: function (value) {
                if (value !== this.checked) {
                    this._checked = coercion.coerceBooleanProperty(value);
                    this._changeDetectorRef.markForCheck();
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcCheckbox.prototype, "touch", {
            get: function () {
                return this._touch;
            },
            set: function (value) {
                this._touch = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcCheckbox.prototype, "disabled", {
            get: function () {
                return this._disabled;
            },
            set: function (value) {
                this.setDisabledState(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcCheckbox.prototype, "indeterminate", {
            /**
             * Alternative state of the checkbox, not user set-able state. Between
             * [checked] and [indeterminate], only one can be true, though both can be
             * false.
             * `true` is INDETERMINATE and `false` is not.
             */
            get: function () {
                return this._indeterminate;
            },
            set: function (value) {
                var _a;
                if (this.disabled) {
                    return;
                }
                var newValue = coercion.coerceBooleanProperty(value);
                if (newValue !== this._indeterminate) {
                    this._indeterminate = newValue;
                    if (newValue) {
                        this.checked = false;
                    }
                    this.indeterminateChange.emit({ source: this, indeterminate: this._indeterminate });
                    this._changeDetectorRef.markForCheck();
                    (_a = this._foundation) === null || _a === void 0 ? void 0 : _a.handleChange();
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcCheckbox.prototype, "indeterminateToChecked", {
            /**
             * Determines the state to go into when [indeterminate] state is toggled.
             * `true` will go to checked and `false` will go to unchecked.
             */
            get: function () {
                return this._indeterminateToChecked;
            },
            set: function (value) {
                this._indeterminateToChecked = coercion.coerceBooleanProperty(value);
                this._changeDetectorRef.markForCheck();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcCheckbox.prototype, "disableRipple", {
            /** Whether the ripple ink is disabled. */
            get: function () {
                return this._disableRipple;
            },
            set: function (value) {
                this._disableRipple = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        MdcCheckbox.prototype.getDefaultFoundation = function () {
            var _this = this;
            // Do not initialize foundation until ngAfterViewInit runs
            if (!this._initialized) {
                return undefined;
            }
            var adapter = {
                addClass: function (className) { return _this._root.classList.add(className); },
                removeClass: function (className) { return _this._root.classList.remove(className); },
                setNativeControlAttr: function (attr, value) {
                    return _this._inputElement.nativeElement.setAttribute(attr, value);
                },
                removeNativeControlAttr: function (attr) { return _this._inputElement.nativeElement.removeAttribute(attr); },
                isIndeterminate: function () { return _this.indeterminate; },
                isChecked: function () { return _this.checked; },
                hasNativeControl: function () { return true; },
                setNativeControlDisabled: function (disabled) { return _this._inputElement.nativeElement.disabled = disabled; },
                forceLayout: function () { return _this._root.offsetWidth; },
                isAttachedToDOM: function () { return true; }
            };
            return new checkbox.MDCCheckboxFoundation(adapter);
        };
        MdcCheckbox.prototype._asyncBuildFoundation = function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this._foundation = this.getDefaultFoundation();
                    return [2 /*return*/];
                });
            });
        };
        MdcCheckbox.prototype.ngAfterViewInit = function () {
            var _this = this;
            this._initialized = true;
            this._asyncBuildFoundation()
                .then(function () {
                _this._foundation.init();
                _this.setDisabledState(_this._inputElement.nativeElement.disabled);
                _this.ripple = _this._createRipple();
                _this.ripple.init();
            });
            this._loadListeners();
        };
        MdcCheckbox.prototype.ngOnDestroy = function () {
            this._destroy.next();
            this._destroy.complete();
            this.ripple.destroy();
            this._foundation.destroy();
        };
        MdcCheckbox.prototype.writeValue = function (value) {
            this.checked = !!value;
        };
        MdcCheckbox.prototype.registerOnChange = function (fn) {
            this._onChange = fn;
        };
        MdcCheckbox.prototype.registerOnTouched = function (fn) {
            this._onTouched = fn;
        };
        /** Focuses the checkbox. */
        MdcCheckbox.prototype.focus = function () {
            if (!this.disabled) {
                this._inputElement.nativeElement.focus();
            }
        };
        MdcCheckbox.prototype.toggle = function (checked) {
            this._setState(checked);
        };
        MdcCheckbox.prototype._onInteraction = function (evt) {
            // We have to stop propagation for click events on the visual hidden input element.
            // Preventing bubbling for the second event will solve that issue.
            evt.stopPropagation();
            this._setState();
            this._onChange(this.checked);
            this._changeDetectorRef.markForCheck();
            this.change.emit(new MdcCheckboxChange(this, this.checked));
        };
        MdcCheckbox.prototype._onInputClick = function (evt) {
            evt.stopPropagation();
        };
        MdcCheckbox.prototype.setDisabledState = function (disabled) {
            var _a;
            var newValue = coercion.coerceBooleanProperty(disabled);
            if (newValue !== this._disabled) {
                this._disabled = newValue;
                (_a = this._foundation) === null || _a === void 0 ? void 0 : _a.setDisabled(newValue);
                this._changeDetectorRef.markForCheck();
            }
        };
        MdcCheckbox.prototype._setState = function (checked) {
            var _this = this;
            if (this.disabled) {
                return;
            }
            if (this.indeterminate) {
                this._checked = this.indeterminateToChecked;
                this.indeterminate = false;
            }
            else {
                this.checked = checked || !this.checked;
            }
            // Reset native input when clicked with noop. The native checkbox becomes checked after
            // click, reset it to be align with `checked` value of `mdc-checkbox`.
            this._inputElement.nativeElement.checked = this.checked;
            this._ngZone.runOutsideAngular(function () {
                return requestAnimationFrame(function () { return _this._foundation.handleChange(); });
            });
        };
        MdcCheckbox.prototype._createRipple = function () {
            var _this = this;
            var adapter = __assign(__assign({}, ripple$1.MdcRipple.createAdapter(this)), { isSurfaceActive: function () { return dom.matches(_this._inputElement.nativeElement, ':active'); }, isUnbounded: function () { return true; }, isSurfaceDisabled: function () { return _this.disableRipple; }, deregisterInteractionHandler: function (evtType, handler) {
                    return _this._inputElement.nativeElement.removeEventListener(evtType, handler, platform.supportsPassiveEventListeners());
                }, registerInteractionHandler: function (evtType, handler) {
                    return _this._inputElement.nativeElement.addEventListener(evtType, handler, platform.supportsPassiveEventListeners());
                } });
            return new ripple$1.MdcRipple(this.elementRef, new ripple.MDCRippleFoundation(adapter));
        };
        MdcCheckbox.prototype._loadListeners = function () {
            var _this = this;
            if (!this._platform.isBrowser) {
                return;
            }
            this._ngZone.runOutsideAngular(function () {
                return rxjs.fromEvent(_this._root, 'animationend')
                    .pipe(operators.takeUntil(_this._destroy), operators.filter(function (e) {
                    return e.target === _this._root;
                }))
                    .subscribe(function () {
                    return _this._ngZone.run(function () { return _this._foundation.handleAnimationEnd(); });
                });
            });
        };
        MdcCheckbox.decorators = [
            { type: core.Component, args: [{
                        selector: 'mdc-checkbox',
                        exportAs: 'mdcCheckbox',
                        host: {
                            '[id]': 'id',
                            'class': 'mdc-checkbox',
                            '[class.mdc-checkbox--touch]': 'touch',
                        },
                        template: "<input type=\"checkbox\"\r\n    #input\r\n    class=\"mdc-checkbox__native-control\"\r\n    [id]=\"inputId\"\r\n    [attr.name]=\"name\"\r\n    [tabIndex]=\"tabIndex\"\r\n    [attr.aria-label]=\"ariaLabel || null\"\r\n    [attr.aria-labelledby]=\"ariaLabelledby\"\r\n    [disabled]=\"disabled\"\r\n    [checked]=\"checked\"\r\n    [attr.value]=\"value\"\r\n    [indeterminate]=\"indeterminate\"\r\n    (change)=\"_onInteraction($event)\"\r\n    (click)=\"_onInputClick($event)\"/>\r\n  <div class=\"mdc-checkbox__background\">\r\n    <svg\r\n      class=\"mdc-checkbox__checkmark\"\r\n      viewBox=\"0 0 24 24\"\r\n      focusable=\"false\">\r\n      <path class=\"mdc-checkbox__checkmark-path\"\r\n        fill=\"none\"\r\n        d=\"M1.73,12.91 8.1,19.28 22.79,4.59\"/>\r\n    </svg>\r\n    <div class=\"mdc-checkbox__mixedmark\"></div>\r\n  </div>\r\n  <div *ngIf=\"!disableRipple && !disabled\" class=\"mdc-checkbox__ripple\"></div>",
                        providers: [
                            MDC_CHECKBOX_CONTROL_VALUE_ACCESSOR,
                            ripple$1.MdcRipple,
                            { provide: formField.MdcFormFieldControl, useExisting: MdcCheckbox }
                        ],
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush
                    }] }
        ];
        /** @nocollapse */
        MdcCheckbox.ctorParameters = function () { return [
            { type: platform.Platform },
            { type: core.NgZone },
            { type: core.ChangeDetectorRef },
            { type: core.ElementRef },
            { type: ripple$1.MdcRipple },
            { type: formField.MdcFormField, decorators: [{ type: core.Optional }] }
        ]; };
        MdcCheckbox.propDecorators = {
            id: [{ type: core.Input }],
            name: [{ type: core.Input }],
            checked: [{ type: core.Input }],
            touch: [{ type: core.Input }],
            disabled: [{ type: core.Input }],
            value: [{ type: core.Input }],
            indeterminate: [{ type: core.Input }],
            indeterminateToChecked: [{ type: core.Input }],
            disableRipple: [{ type: core.Input }],
            tabIndex: [{ type: core.Input }],
            ariaLabel: [{ type: core.Input, args: ['aria-label',] }],
            ariaLabelledby: [{ type: core.Input, args: ['aria-labelledby',] }],
            change: [{ type: core.Output }],
            indeterminateChange: [{ type: core.Output }],
            _inputElement: [{ type: core.ViewChild, args: ['input', { static: true },] }]
        };
        return MdcCheckbox;
    }(base.MDCComponent));

    var MdcCheckboxModule = /** @class */ (function () {
        function MdcCheckboxModule() {
        }
        MdcCheckboxModule.decorators = [
            { type: core.NgModule, args: [{
                        imports: [common.CommonModule, formField.MdcFormFieldModule],
                        exports: [
                            formField.MdcFormFieldModule,
                            MdcCheckbox
                        ],
                        declarations: [MdcCheckbox]
                    },] }
        ];
        return MdcCheckboxModule;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    exports.MDC_CHECKBOX_CONTROL_VALUE_ACCESSOR = MDC_CHECKBOX_CONTROL_VALUE_ACCESSOR;
    exports.MdcCheckbox = MdcCheckbox;
    exports.MdcCheckboxChange = MdcCheckboxChange;
    exports.MdcCheckboxModule = MdcCheckboxModule;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=web-checkbox.umd.js.map
